import axios from 'axios'
import { DEFAULT_LANGUAGE, SUPPORTED_CULTURES } from './constants'
import { i18n } from './i18n'

const Translation = {
  get defaultLanguage () {
    return DEFAULT_LANGUAGE
  },
  get supportedLanguages () {
    let supported = SUPPORTED_CULTURES.map(a => a.twoLetter)
    return supported
  },
  get supportedLanguagesFull () {
    return SUPPORTED_CULTURES
  },
  get currentLanguage () {
    return i18n.locale
  },
  set currentLanguage (locale) {
    i18n.locale = locale
  },
  /**
   * Gets the first supported language that matches the user's
   * @return {String}
   */
  getUserSupportedLang () {
    const userPreferredLang = Translation.getUserLang()

    // Check if user preferred browser lang is supported
    if (Translation.isLangSupported(userPreferredLang.lang)) {
      return userPreferredLang.lang
    }
    // Check if user preferred lang without the ISO is supported
    if (Translation.isLangSupported(userPreferredLang.langNoISO)) {
      return userPreferredLang.langNoISO
    }
    return Translation.defaultLanguage
  },
  /**
   * Gets two letter locale code and return four letter one
   * @param {String} locale
   */
  getLocaleCulture (locale) {
    let found = SUPPORTED_CULTURES.filter(a => a.twoLetter === locale)
    return found.length > 0
      ? found[0].culture
      : null
  },
  /**
   * Returns the users preferred language
   */
  getUserLang () {
    const lang = window.navigator.language || window.navigator.userLanguage || Translation.defaultLanguage
    return {
      lang: lang,
      langNoISO: lang.split('-')[0]
    }
  },
  /**
   * Sets the language to various services (axios, the html tag etc)
   * @param {String} lang
   * @return {String} lang
   */
  setI18nLanguageInServices (locale) {
    Translation.currentLanguage = locale
    axios.defaults.headers.common['Accept-Language'] = locale
    document.querySelector('html').setAttribute('lang', locale)
    return locale
  },
  /**
   * Loads new translation messages and changes the language when finished
   * @param lang
   * @return {Promise<any>}
   */
  changeLanguage (locale) {
    if (!Translation.isLangSupported(locale)) {
      return Promise.reject(new Error('Language not supported'))
    }
    if (i18n.locale === locale) {
      return Promise.resolve(Translation.setI18nLanguageInServices(locale))
    }
    return Translation.loadLanguageFile(locale).then(msgs => {
      i18n.setLocaleMessage(locale, msgs.default || msgs)
      return Translation.setI18nLanguageInServices(locale)
    })
  },
  /**
   * Async loads a translation file
   * @param lang
   * @return {Promise<*>|*}
   */
  loadLanguageFile (locale) {
    return import(/* webpackChunkName: "lang-[request]" */ `@/locales/${locale}/index.json`)
  },
  /**
   * Checks if a lang is supported
   * @param {String} lang
   * @return {boolean}
   */
  isLangSupported (locale) {
    let includes = false
    Translation.supportedLanguages.forEach(function (l) {
      if (l === locale) {
        includes = true
      }
    })
    return includes
  },
  /**
   * Checks if the route's param is supported, if not, redirects to the first supported one.
   * @param {Route} to
   * @param {Route} from
   * @param {Function} next
   * @return {*}
   */
  routeMiddleware (to, from, next) {
    let locale = to.params.locale
    if (!this.isLangSupported(locale)) {
      locale = this.defaultLanguage
    }
    return Translation.changeLanguage(locale).then(() => next())
  },
  t (localeRefference) {
    return i18n.t(localeRefference)
  }
}

export {
  Translation
}



// WEBPACK FOOTER //
// ./src/utils/Translation.js